var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import mixpanel from "mixpanel-browser";
import { ClientJS } from "clientjs";
import getIP from "@/utilities/getIP";
import MPSessionStorage from "@/services/MPSessionStorage";
import MPStorage from "@/services/LocalStorage";
import { decodeTokenData } from "@/api/utils";
import { adminStoreInstance } from "@/services/store/adminStoreInstance";
import config from "@/config";
import { getCookieValue } from "../utils";
var getUniwabaMixpanelProps = function () {
    var _a, _b;
    var flow = MPSessionStorage.get(MPSessionStorage.keys.FLOW);
    var isUniwabaPartner = ((_b = (_a = adminStoreInstance.currentPartner) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.isUniwabaPartner) === true;
    return {
        is_marketplace_client: flow === "uniwaba" || isUniwabaPartner
    };
};
var client = new ClientJS();
var fp = {
    fingerprint: client.getFingerprint(),
    userAgent: client.getUserAgent(),
    browser: client.getBrowser(),
    browserVersion: client.getBrowserVersion(),
    os: client.getOS(),
    osVersion: client.getOSVersion(),
    device: client.getDevice(),
    isCookie: client.isCookie(),
    timeZone: client.getTimeZone(),
    language: client.getLanguage(),
    systemLanguage: client.getSystemLanguage()
};
var getMixpanelProjectToken = function () {
    switch (process.env.CURRENT_ENV) {
        case "production":
            return config.MIXPANEL_PROJECT_TOKEN_PRODUCTION;
        case "rc":
            return config.MIXPANEL_PROJECT_TOKEN_RC;
        case "staging":
            return config.MIXPANEL_PROJECT_TOKEN_STAGING;
        case "development":
        case "local":
            return config.MIXPANEL_PROJECT_TOKEN_DEVELOPMENT;
        default:
            return config.MIXPANEL_PROJECT_TOKEN_PRODUCTION;
    }
};
var mixpanelToken = getMixpanelProjectToken();
var initMixpanel = function () {
    if (!mixpanelToken)
        return;
    mixpanel.init(mixpanelToken, {
        api_host: config.MIXPANEL_API_HOST,
        lib_base_path: config.MIXPANEL_LIB_BASE_PATH,
        api_routes: {
            track: "m/t",
            engage: "m/e",
            groups: "m/g",
            record: "m/r"
        },
        debug: process.env.CURRENT_ENV === "development" ||
            process.env.CURRENT_ENV === "local",
        track_pageview: false,
        record_sessions_percent: 1,
        record_mask_all_text: false,
        record_mask_text_selector: 'input, textarea, select, [contenteditable="true"]',
    });
};
if (mixpanelToken && getCookieValue("cookieAnalytics") === "true") {
    initMixpanel();
}
export { initMixpanel };
var env_check = !!mixpanelToken &&
    ["production", "rc", "staging", "development", "local"].includes(process.env.CURRENT_ENV || "");
// Cache IP address - fetched once when user is identified
var cachedIP = null;
var lastAppliedMixpanelIdentityKey = "";
var getUserDetails = function () {
    var currentUserStorage = MPSessionStorage.get(MPSessionStorage.keys.CURRENT_USER);
    var currentClientStorage = MPSessionStorage.get(MPSessionStorage.keys.CURRENT_CLIENT);
    var currentUser = JSON.parse(currentUserStorage || "{}");
    var currentClient = JSON.parse(currentClientStorage || "{}");
    var roles = (currentUser && currentUser.roles) || [];
    var isPartner = roles.some(function (role) { return role.startsWith("partner"); });
    var isClient = roles.some(function (role) { return role.startsWith("client"); });
    return {
        partnerId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.activePartner,
        clientId: (currentClient === null || currentClient === void 0 ? void 0 : currentClient.id) || undefined,
        orgType: isPartner ? "partner" : isClient ? "client" : ""
    };
};
var SEND_IMMEDIATELY_TIMEOUT_MS = 1000;
var SEND_IMMEDIATELY_IP_TIMEOUT_MS = 300;
var cacheIP = function (ip) {
    if (ip && !cachedIP) {
        cachedIP = ip;
    }
};
var actions = {
    alias: function (id) {
        var _a;
        if (env_check)
            (_a = mixpanel.alias) === null || _a === void 0 ? void 0 : _a.call(mixpanel, id);
    },
    identify: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!env_check) return [3 /*break*/, 2];
                    try {
                        (_a = mixpanel.identify) === null || _a === void 0 ? void 0 : _a.call(mixpanel, id);
                    }
                    catch (e) {
                        console.warn("Mixpanel identify failed:", e);
                    }
                    if (!!cachedIP) return [3 /*break*/, 2];
                    return [4 /*yield*/, getIP().catch(function () { return null; })];
                case 1:
                    cachedIP = _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); },
    track: function (_a) {
        var name = _a.name, description = _a.description, displayName = _a.displayName, props = _a.props, options = _a.options;
        return __awaiter(void 0, void 0, void 0, function () {
            var userDetails, ipPromise, ipTimer_1, ipTimeout, _b, _c, payload_1, requestOptions_1, dispatchError_1, dispatchFailed_1, e_1;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        userDetails = getUserDetails();
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 9, , 10]);
                        if (!env_check) return [3 /*break*/, 8];
                        if (!!cachedIP) return [3 /*break*/, 5];
                        ipPromise = getIP().catch(function () { return null; });
                        if (!(options === null || options === void 0 ? void 0 : options.sendImmediately)) return [3 /*break*/, 3];
                        // An un-timed third-party fetch must not hold a caller that is leaving.
                        void ipPromise.then(cacheIP);
                        ipTimeout = new Promise(function (resolve) {
                            ipTimer_1 = setTimeout(function () { return resolve(null); }, SEND_IMMEDIATELY_IP_TIMEOUT_MS);
                        });
                        _b = cacheIP;
                        return [4 /*yield*/, Promise.race([ipPromise, ipTimeout])];
                    case 2:
                        _b.apply(void 0, [_e.sent()]);
                        clearTimeout(ipTimer_1);
                        return [3 /*break*/, 5];
                    case 3:
                        _c = cacheIP;
                        return [4 /*yield*/, ipPromise];
                    case 4:
                        _c.apply(void 0, [_e.sent()]);
                        _e.label = 5;
                    case 5:
                        payload_1 = __assign(__assign(__assign(__assign({}, props), getUniwabaMixpanelProps()), { fingerprint: __assign(__assign({}, fp), { ip: cachedIP }), description: description, displayName: displayName, app: "partner_hub", active_org_type: userDetails.orgType, $groups: __assign({ partner_id: userDetails.partnerId || (props === null || props === void 0 ? void 0 : props.partnerId) }, ((userDetails.clientId || (props === null || props === void 0 ? void 0 : props.clientId)) && {
                                client_id: userDetails.clientId || (props === null || props === void 0 ? void 0 : props.clientId)
                            })), environment: process.env.CURRENT_ENV, partner_id: userDetails.partnerId || (props === null || props === void 0 ? void 0 : props.partnerId) }), ((userDetails.clientId || (props === null || props === void 0 ? void 0 : props.clientId)) && {
                            client_id: userDetails.clientId || (props === null || props === void 0 ? void 0 : props.clientId)
                        }));
                        if (!(options === null || options === void 0 ? void 0 : options.sendImmediately)) return [3 /*break*/, 7];
                        requestOptions_1 = { send_immediately: true };
                        dispatchFailed_1 = false;
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var _a;
                                var settled = false;
                                var finish = function () {
                                    if (settled)
                                        return;
                                    settled = true;
                                    clearTimeout(fallbackTimer);
                                    resolve();
                                };
                                var fallbackTimer = setTimeout(finish, SEND_IMMEDIATELY_TIMEOUT_MS);
                                try {
                                    (_a = mixpanel.track) === null || _a === void 0 ? void 0 : _a.call(mixpanel, name, payload_1, requestOptions_1, finish);
                                }
                                catch (e) {
                                    dispatchError_1 = e;
                                    dispatchFailed_1 = true;
                                    finish();
                                }
                            })];
                    case 6:
                        _e.sent();
                        // Deferred: a throw inside the executor after resolve() is swallowed.
                        if (dispatchFailed_1) {
                            throw dispatchError_1;
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        (_d = mixpanel.track) === null || _d === void 0 ? void 0 : _d.call(mixpanel, name, payload_1);
                        _e.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_1 = _e.sent();
                        console.warn("Mixpanel tracking failed:", e_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    },
    people: {
        set: function (props) {
            var _a, _b;
            try {
                if (env_check)
                    (_b = (_a = mixpanel.people) === null || _a === void 0 ? void 0 : _a.set) === null || _b === void 0 ? void 0 : _b.call(_a, props);
            }
            catch (e) {
                console.warn("Mixpanel people.set failed:", e);
            }
        },
        set_once: function (props) {
            var _a, _b;
            try {
                if (env_check)
                    (_b = (_a = mixpanel.people) === null || _a === void 0 ? void 0 : _a.set_once) === null || _b === void 0 ? void 0 : _b.call(_a, props);
            }
            catch (e) {
                console.warn("Mixpanel people.set_once failed:", e);
            }
        }
    },
    reset: function () {
        if (env_check) {
            try {
                mixpanel.reset();
            }
            catch (e) {
                console.warn("Mixpanel reset failed:", e);
            }
            cachedIP = null;
            lastAppliedMixpanelIdentityKey = "";
        }
    },
    register: function (props) {
        var _a;
        if (env_check) {
            try {
                (_a = mixpanel.register) === null || _a === void 0 ? void 0 : _a.call(mixpanel, props);
            }
            catch (e) {
                console.warn("Mixpanel register failed:", e);
            }
        }
    }
};
export var applyMixpanelUserFromProfile = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var trimmedAuth0, fallbackDistinctId, token, decoded, sub, distinctId, dedupeKey;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                trimmedAuth0 = (_a = user.auth0UserId) === null || _a === void 0 ? void 0 : _a.trim();
                fallbackDistinctId = "";
                token = MPStorage.requestCacheAuthenticate().token;
                if (token) {
                    try {
                        decoded = decodeTokenData(token);
                        sub = (_b = decoded.auth0Sub) === null || _b === void 0 ? void 0 : _b.trim();
                        if (sub) {
                            fallbackDistinctId = sub;
                        }
                        else if (decoded.userId) {
                            fallbackDistinctId = decoded.userId;
                        }
                    }
                    catch (_e) {
                        // ignore wrong token
                    }
                }
                distinctId = trimmedAuth0 || fallbackDistinctId;
                if (!distinctId) {
                    return [2 /*return*/];
                }
                dedupeKey = "".concat(distinctId, "\0").concat((_c = user.email) !== null && _c !== void 0 ? _c : "");
                if (dedupeKey === lastAppliedMixpanelIdentityKey) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, actions.identify(distinctId)];
            case 1:
                _d.sent();
                if (user.email) {
                    actions.register({ email: user.email });
                    actions.people.set({ $email: user.email, email: user.email });
                }
                lastAppliedMixpanelIdentityKey = dedupeKey;
                return [2 /*return*/];
        }
    });
}); };
export var Mixpanel = actions;
//# sourceMappingURL=data:application/json;base64,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